import { ModelFamily } from '../types';


export type Assistant = {
    modelFamily: ModelFamily;
    label: string;
    iconUrl: string;
};

// ChatGPT first: it is the assistant the report has always shown.
export const assistantsDisplayOrder: ModelFamily[] = ['gpt', 'gemini', 'claude'];

// The product name and the logo live here and nowhere else. The API stores and returns the model
// family - `gpt`, `gemini`, `claude` - and what a customer is shown for it is a display decision,
// so a renamed product or a new logo file is a change to this one table.
export const assistants: Record<ModelFamily, Assistant> = {
    gpt: { modelFamily: 'gpt', label: 'ChatGPT', iconUrl: '/images/chatgpt-logo.svg' },
    gemini: { modelFamily: 'gemini', label: 'Gemini', iconUrl: '/images/gemini-logo.svg' },
    claude: { modelFamily: 'claude', label: 'Claude', iconUrl: '/images/claude-logo.svg' },
};
